package com.devi3east.bashbuddy.features.events.detail.ui.components

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Add
import androidx.compose.material.icons.filled.Remove
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.LocalTextStyle
import androidx.compose.material3.OutlinedTextField
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.semantics.contentDescription
import androidx.compose.ui.semantics.semantics
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp

@Composable
fun QuantitySelector(
    quantity: Int,
    onQuantityChange: (Int) -> Unit,
    onSetQuantity: ((Int) -> Unit)? = null,
    modifier: Modifier = Modifier,
    minQuantity: Int = 0,
    maxQuantity: Int = 999
) {
    Row(
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(4.dp),
        modifier = modifier
    ) {
        IconButton(
            onClick = { if (quantity > minQuantity) onQuantityChange(quantity - 1) },
            enabled = quantity > minQuantity,
            modifier = Modifier.semantics { contentDescription = "Decrease quantity" }
        ) {
            Icon(Icons.Default.Remove, contentDescription = null)
        }

        OutlinedTextField(
            value = quantity.toString(),
            onValueChange = { input ->
                val num = input.toIntOrNull() ?: minQuantity
                val clamped = num.coerceIn(minQuantity, maxQuantity)
                onQuantityChange(clamped)
            },
            singleLine = true,
            keyboardOptions = KeyboardOptions.Default.copy(keyboardType = KeyboardType.Number),
            textStyle = LocalTextStyle.current.copy(textAlign = TextAlign.Center),
            modifier = Modifier.width(64.dp)
        )

        IconButton(
            onClick = { if (quantity < maxQuantity) onQuantityChange(quantity + 1) },
            enabled = quantity < maxQuantity,
            modifier = Modifier.semantics { contentDescription = "Increase quantity" }
        ) {
            Icon(Icons.Default.Add, contentDescription = null)
        }
    }

    // Programmatically set quantity if onSetQuantity is called
    onSetQuantity?.let { setter ->
        setter(quantity.coerceIn(minQuantity, maxQuantity))
    }
}